<template>
  <Dialog
    :visible="showDialog"
    modal
    dismissable-mask
    position="center"
    :show-header="false"
    :closable="false"
    :draggable="false"
    class="tw:max-w-[430px]"
    :pt="{
      content: { class: 'tw:p-[24px] tw:relative' },
    }"
  >
    <main class="tw:flex tw:flex-col tw:items-center tw:text-center tw:space-y-4">
      <!-- Close button -->
      <button 
        @click="closeDialog"
        class="tw:absolute tw:top-4 tw:right-4 tw:w-8 tw:h-8 tw:flex tw:items-center tw:justify-center tw:rounded-full tw:bg-gray-100 hover:tw:bg-gray-200 tw:transition-colors"
        aria-label="Close dialog"
      >
        <i class="pi pi-times tw:text-gray-600 tw:text-sm"></i>
      </button>

      <!-- WiFi icon -->
      <i class="pi pi-wifi tw:text-[#EB3B5A] tw:text-[2rem]" style="font-weight: 600"></i>
      
      <!-- Title -->
      <h2 class="tw:text-[18px] tw:font-semibold tw:text-black tw:mt-4">No Internet Connection</h2>
      
      <!-- Description -->
      <p class="tw:text-[#8A8A8C] tw:text-[14px] tw:font-semibold">
        You're offline. Some features may not work.
      </p>

      <!-- Retry button -->
      <Button 
        @click="handleRetry"
        class="tw:mt-4 tw:px-6 tw:py-2 tw:bg-[#007AFF] tw:text-white tw:rounded-lg tw:font-semibold hover:tw:bg-[#0056CC] tw:transition-colors"
        :loading="isRetrying"
      >
        <i class="pi pi-refresh tw:mr-2"></i>
        Retry
      </Button>
    </main>
  </Dialog>
</template>

<script setup>
import { ref } from 'vue'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { useNetworkStatus } from '@/composables/useNetworkStatus'

const { showDialog, closeDialog, retryConnection } = useNetworkStatus()
const isRetrying = ref(false)

const handleRetry = async () => {
  isRetrying.value = true
  await retryConnection()
  isRetrying.value = false
}
</script>
